Bar(v-if='currentStatistics && !currentStatistics.isOpenQuestion' :data='chartData' :options='chartOptions' data-test='results.statistics.chart')

table.fp-table(v-else-if='currentStatistics' data-test='results.statistics.list')
  tbody
    tr(v-for='answer in currentStatistics.answers')
      td {{ answer.text }}
